import { DataStore } from 'flux-store';
import { Command, CommandInterfaces, StateService } from 'flux-core';
import { Injectable, Inject } from '@angular/core';
import { AbstractMessageCommand } from 'flux-connection';
import { Observable, from } from 'rxjs';
import { UserModel } from '../model/user.mdl';

/**
 * This is the command add/updates demo user's feedback for the app.
 */
@Injectable()
@Command()
export class SubmitDemoSurvey extends AbstractMessageCommand {

    public static get dataDefinition(): {}  {
        return {
            uid: true,
            rating: true,
        };
    }

    public static get implements(): Array<CommandInterfaces> {
        return [
            'IMessageCommand',
            'IUserCommand',
        ];
    }

    constructor(
        protected dataStore: DataStore,
        @Inject( StateService ) protected state: StateService< any, any > ) {
        super()/* istanbul ignore next */;
    }

    /**
     * Store user survey feedback
     */
    public execute(): Observable<any> {
        const modelStore = this.dataStore.getModelStore(UserModel);
        const feedback = {
            rating: this.data.rating,
            feedback: this.data.feedback || '',
            ratingReason: this.data.ratingReason,
            diagramChangesCount: this.data.diagramChangesCount,
            firstLandingPage: this.data.firstLandingPage,
            browser: this.data.browser,
            os: this.data.os,
            templateId: this.data.templateId,
            country: this.data.country,
            sessionLengthMinutes: this.data.sessionLengthMinutes,
        };

        const setter = { $set: {} };
        setter.$set['demoSurveyFeedback'] = feedback;

        return from(modelStore.update(
            { id: this.state.get('CurrentUser') },
            setter
        ));
    }
}

Object.defineProperty( SubmitDemoSurvey, 'name', {
    value: 'SubmitDemoSurvey',
});
